





















import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';

@Component({
  name: 'bpc-input-tags',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class InputTags extends mixins(AbstractField) {
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly value: string[];
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly tagRules: string[];

  get model(): string[] {
    return this.value;
  }
  set model(val: string[]) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  tagValidator(tag) {
    // Individual tag validator function
    let valid = true;
    this.tagRules.forEach(rule => {
      switch (rule) {
        case 'email':
          if (!tag.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)) {
            valid = false;
          }
          break;
        default:
          valid = true;
      }
    });

    return valid;
  }
}
